<template>
  <div class="container">
    <h1>We are Team Misfit</h1>
    <p>We're a team focused on indie games development based in Warsaw.</p>
    <h2>Our games</h2>
    <GamesList/>
  </div>
</template>

<script>
// @ is an alias to /src
import GamesList from '@/components/GamesList.vue'

export default {
  name: 'HomeView',
  components: {
    GamesList
  }
}
</script>
<style lang="scss" scoped >
h1, h2, h3, p {
  text-align: center;
}
.container {
  padding: 0 30px;
    width: calc(100% - 60px);
}
@media screen and (max-width: 580px) {
  .container {
    width: calc(100% - 40px);
    padding: 0 20px;
  }
}
</style>
